import * as React from 'react'
import HexPattern from 'components/common/HexPattern'
import SanityBlock from 'components/common/SanityBlock'
import Img from 'components/common/Img'

const CaseStudyContent = ({ content, overview }) => (
	<section id="case-study-content" className="relative">
		<HexPattern />

		<div className="relative grid md:grid-cols-[2fr,minmax(300px,1fr)] gap-y-8 gap-x-16 max-w-screen-xl mx-auto py-20 px-4">
			<div>
				{content?.map(({ title, _rawDescription }, key) => (
					<article className="richtext mb-12 last:mb-0" key={key}>
						<h2 className="h1">{title}</h2>
						<SanityBlock body={_rawDescription} />
					</article>
				))}
			</div>

			{!!overview && (
				<aside className="sticky-below-header md:self-start bg-ft-gray-light richtext p-8 <md:fullwidth <md:p-6">
					<Img
						className="max-h-[70px] mix-blend-multiply"
						objectFit="contain"
						{...overview.image}
					/>

					<h2 className="h4">Overview</h2>
					<SanityBlock className="text-[14px]" body={overview._rawContent} />
					{overview.fields?.map(({ title, value }, key) => (
						<dl key={key}>
							<dt className="font-bold">{title}</dt>
							<dd className="text-[14px]">{value}</dd>
						</dl>
					))}
				</aside>
			)}
		</div>
	</section>
)

export default CaseStudyContent
